<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Típus"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.type === 'move'"
        size="small"
      >
        Végleges áthelyezés
      </el-tag>
      <el-tag
        v-else
        size="small"
        type="warning"
      >
        Helyettesítés
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'type',
  };
</script>
